import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';

// Se encacarga de listar los campos dinamicos de una compa��a
export const ObtenerListadoCamposDinamicos = (Parametros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CamposDinamicos/Listado', Parametros).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de listar los campos dinamicos tipo radios de una compa��a
export const ObtenerListadoCamposDinamicosRadios = (Parametros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CamposDinamicos/ListadoRadios', Parametros).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

// Se encacarga de guardar los campos dinamicos de una compa��a
export const GuadarInfoCamposDinamicos = (Parametros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CamposDinamicos/Save', Parametros).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

/**
 * 
 * @param {{ companyId:string,
 * portal:string,
 * idRel:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} Parametros
 * @returns {Promise<{data:{sectionId:string,
 * sectionName:string,
 * fieldList:{ 
 * fieldId:string,
 * sectionId:string, 
 * typeField:string, 
 * fieldDescrp:string, 
 * isRequired:boolean,
 * dataField:string,
 * displayOrder:string,
 * pattern:string, 
 * maxlength:string, 
 * minimum:string,
 * maximum:string,
 * minDate:string,
 * maxDate:string,
 * decimal:string, 
 * value:string,
 * fieldName:string, listRecords:string }[] }[], status:number, errors:{}}>}
 */
export const listadoCamposDinamicosPortal = (Parametros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CamposDinamicos/CamposPortal', Parametros).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

/**
 * 
 * @param {{ companyId:string,
 * portal:string,
 * idRel:string,
 * userId:string,
 * fieldList:{fieldId:string, fieldName:string, dataField:string}[],
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string } }} Parametros
 * @returns {Promise<{data:{}, status:number, errors:{}}>}
 */
export const gestionCamposDinamicosPortal = (Parametros) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post('/CamposDinamicos/GestionarPortal', Parametros).then(response => {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    });
};

export default ObtenerListadoCamposDinamicos